import React from 'react';
import VBPopup from "@vb-js-commons/vbPopup";
import ProgressChartSection from './ProgressChartSection'
import ProgressCircle from './ProgressCircle';
import RichTypography from './RichTypography';

import styled from 'styled-components'

const RangeInput = styled.input`
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  cursor: pointer;
  width: 100%;
  height: 10px;
  :focus {
    outline: none;
  }
  /* Chrome, Safari, Opera and Edge Chromium styles */
  ::-webkit-slider-runnable-track {
    background-color: transparent;
    border-radius: 0.5rem;
    height: 0.5rem;
  }
  ::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    margin-top: -4px; /* Centers thumb on the track */
       background-color: #355D5E !important;
    border-radius: 0.5rem;
    height: 1rem;
    width: 1rem;
  }
  :focus::-webkit-slider-thumb {
    outline: 3px solid #355D5E;
    outline-offset: 0.125rem;
  }
  /*For firefox styles*/
  ::-moz-range-track {
    background-color: transparent;
    border-radius: 0.5rem;
    height: 0.5rem;
  }
  ::-moz-range-thumb {
    background-color: #355D5E !important;
    border: none; /*Removes extra border that FF applies*/
    border-radius: 0.5rem;
    height: 1rem;
    width: 1rem;
  }
  :focus::-moz-range-thumb{
    outline: 3px solid #355D5E;
    outline-offset: 0.125rem;
  }
`


class ComparisonRealPrice extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      procent_timber: 75,
      info_top: true,
      info_bottom: false,
      popup_desc: ""
    }
    this.popup = React.createRef();
  }

  componentDidMount() {
    const slider = document.getElementById("range")
    const min = slider.min
    const max = slider.max
    const value = slider.value

    const ele = document.querySelector('.label');
    if (ele) {
      const newVal = Number(((value - 0) * 100) / (100 - 0));
      ele.style.left = `calc(${newVal}% + (${8 - newVal * 0.50}px))`;
    }

    slider.style.background = `linear-gradient(to right, #355D5E 0%, #355D5E ${(value - min) / (max - min) * 100}%, #023436 ${(value - min) / (max - min) * 100}%, #023436 100%)`;

    slider.oninput = function (e) {
      this.style.background = `linear-gradient(to right, #355D5E 0%, #355D5E ${(this.value - this.min) / (this.max - this.min) * 100}%, #023436 ${(this.value - this.min) / (this.max - this.min) * 100}%, #023436 100%)`
    };
  };

  show_popup(text) {
    let desc = <p>Nedan kan du se verkliga virkespriser i din kommun angett i kr/m3fub netto. Alltså efter avverkningskostnader. Informationen baseras på avslut på Treebula och information från skogsägare. Priserna nedan är för en slutavverkning med 100% {this.props.tree_name}</p>;
    if (text == "two") {
      desc = <p>Slutavverkning av grov skog har normalt en timmerandel mellan 80-90%. Klenare skog har normalt en timmerandel mellan 50-60%. Tänk på att här visas priser för det trädslag du har valt. Normalt faller en blandning av trädslag ut.</p>;
    }
    this.popup.current.setState({ visible: true, desc: desc });
    this.setState({ popup_desc: desc });
  }


  render() {
    return <div className="container" style={{ padding: '1rem 0rem ' }}>
      <ProgressChartSection
        title={this.props.title}  
        defaultColumnWidth='col-12 col-md-10'
        description={this.props.description}>
        <div className="row justify-content-center">
          <div className='mt-0 mt-lg-5'>
            <RichTypography className='pine'>{this.props.heading}</RichTypography>
          </div>
          <p className='neutral-charcoal mb-2'>Nedan visas nettopriser. Ange ungefärlig timmerandel i din avverkning. Variationer förekommer och hör alltid med oss innan du gör affär.</p>
          {!this.props.has_premium ? <p className='neutral-charcoal'> Eftersom du inte har Skogsövervakning kan du inte se alla priserna – du kan skaffa det det <a className="pine" href="/min-skog/?view=overvakning" style={{ fontWeight: 700 }}>här.</a></p> : null}
          <div className='col-12 col-md-8 col-lg-6 d-flex flex-row flex-md-nowrap  justify-content-center  justify-content-md-between align-items-center py-0  py-lg-3 py-xl-5'>
            <ProgressCircle
              has_premium={this.props.has_premium === true ? true : false}
              name="LÅGT PRIS"
              value={100}
              valueNumber={Math.round((this.props.data.timber_low * this.state.procent_timber) / 100 + (this.props.data.pulp_low * (100 - this.state.procent_timber) / 100))}
              /* value={Math.round((100 / this.props.data.timber_high) * ((this.props.data.timber_low * this.state.procent_timber) / 100 + (this.props.data.pulp_low * (100 - this.state.procent_timber) / 100)))} */
              duration={0.3}
              textColor='#F26157'
              pathColor='#F26157'
              trailColor="#4C2B36"
            />
            <ProgressCircle
              has_premium={this.props.has_premium === true ? true : false}
              name="MEDEL PRIS"
              value={100}
              valueNumber={Math.round((this.props.data.timber_medium * this.state.procent_timber / 100) + (this.props.data.pulp_medium * (100 - this.state.procent_timber) / 100))}
              /*value={Math.round((100 / this.props.data.timber_high) * ((this.props.data.timber_medium * this.state.procent_timber / 100) + (this.props.data.pulp_medium * (100 - this.state.procent_timber) / 100)))} */
              duration={0.3}
              textColor="#2FAF9A"
              pathColor="#2FAF9A"
              trailColor="#023436"
            />
            <ProgressCircle
              has_premium={this.props.has_premium === true ? true : false}
              name="HÖGT PRIS"
              value={100}
              valueNumber={Math.round((this.props.data.timber_high * this.state.procent_timber / 100) + (this.props.data.pulp_high * (100 - this.state.procent_timber) / 100))}
              /*  value={Math.round((100 / this.props.data.timber_high) * ((this.props.data.timber_high * this.state.procent_timber / 100) + (this.props.data.pulp_high * (100 - this.state.procent_timber) / 100)))} */
              duration={0.3}
              textColor="#6A58C6"
              pathColor="#6A58C6"
              trailColor="#232347"
            />
          </div>
          <div class="col-12" style={{ padding: "3rem 1rem" }}>
            <form className="slider-parent" style={{ position: "relative" }}>
              <RangeInput
                id="range"
                min={0}
                max={100}
                type="range"
                className="form-range"
                value={this.state.procent_timber}
                onChange={(e) => {
                  const ele = document.querySelector('.label');
                  if (ele) {
                    const newVal = Number(((e.target.value - 0) * 100) / (100 - 0));
                    ele.style.left = `calc(${newVal}% + (${8 - newVal * 0.50}px))`;
                  }

                  this.setState({ procent_timber: e.target.value })
                }} />
              <div className="label" style={{ position: "absolute" }}>
                <p class="float-start neutral-charcoal" style={{ fontWeight: 700, paddingTop: '8px' }}>{this.state.procent_timber == 0 || this.state.procent_timber == 100 ? null : `${this.state.procent_timber}%`}</p>
              </div>
              <p class="float-start neutral-charcoal" style={{ fontWeight: 900 }}>0%</p>
              <p class="float-end neutral-charcoal" style={{ fontWeight: 900 }}>100%</p>
            </form>
          </div>
        </div>
      </ProgressChartSection>

      <div className='py-2 justify-content-start'>
         {this.props.has_premium ? <p className='text-start neutral-charcoal mb-5'> Justera efter förväntat timmerutfall.
          Har du fått ett anbud från ett skogsbolag? - <a href="mailto:info@treebula.se?subject=Jag vill ha hjälp att jämföra anbud" className='neutral-charcoal' style={{ fontWeight: 700 }}>Klicka här så hjälper vi dig att jämföra</a>
        </p>: null}
      </div>

    </div>;
  }
}



export default ComparisonRealPrice;